import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

import mixin from "../src/Mixins/global-mixin";
import "./Mixins/gtm";

import "../public/dist/css/pages/icon-page.css";
import "../public/dist/css/pages/timeline-vertical-horizontal.css";
import "../public/dist/css/pages/stylish-tooltip.css";
import "../public/dist/css/pages/tab-page.css";
import "../node_modules/datatables.net-bs4/css/dataTables.bootstrap4.css";
// import "../node_modules/datatables.net-bs4/css/responsive.dataTables.min.css";
import "../public/dist/css/style.css";
import "../public/dist/css/custom.css";
import "../public/dist/css/pages/floating-label.css";
import "../node_modules/bootstrap-daterangepicker/daterangepicker.css";
import "../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import "../node_modules/select2/dist/css/select2.min.css";
import "../node_modules/switchery/switchery.css";
import "../node_modules/bootstrap-select/dist/css/bootstrap-select.min.css";
import "../node_modules/bootstrap-tagsinput/dist/bootstrap-tagsinput.css";
import "../node_modules/bootstrap-touchspin/dist/jquery.bootstrap-touchspin.min.css";
import "../node_modules/multiselect/css/multi-select.css";
//<!--alerts CSS -->
import "../node_modules/sweetalert2/dist/sweetalert2.min.css";
//<!-- toast CSS -->
// import "../public/assets/node_modules/toast-master/css/jquery.toast.css";
//<!-- page css -->
import "../public/dist/css/pages/other-pages.css";
import "../public/dist/css/pages/chat-app-page.css";
import "../public/dist/css/pages/inbox.css";
//<!-- wysihtml5 CSS -->
import "../node_modules/html5-editor/src/style.css";
import "../public/dist/css/form.css";
// import "../public/assets/node_modules/dropzone-master/dist/dropzone.css";

import VueTheMask from "vue-the-mask";
import VueLoading from "vue-loading-overlay";
import PrimeVue from "primevue/config";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import Card from "primevue/card";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import "vue-loading-overlay/dist/vue-loading.css";
import Button from "primevue/button";
import Editor from "primevue/editor";
import FileUpload from "primevue/fileupload";
import Message from "primevue/message";
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import SelectButton from "primevue/selectbutton";
import ScrollPanel from "primevue/scrollpanel";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/inputswitch";
import Calendar from "primevue/calendar";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";
import ProgressSpinner from "primevue/progressspinner";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import DataView from "primevue/dataview";
import DataViewLayoutOptions from "primevue/dataviewlayoutoptions";
import TabMenu from "primevue/tabmenu";
import BlockUI from "primevue/blockui";
import Menu from "primevue/menu";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Chip from "primevue/chip";
import Paginator from "primevue/paginator";
import OverlayPanel from "primevue/overlaypanel";
import Divider from "primevue/divider";
import Inplace from "primevue/inplace";
import Badge from "primevue/badge";
import Listbox from "primevue/listbox";

//my Code for Mitt and My hub
import mitt from "mitt";
const emitter = mitt();
//import DisplayHub from './Hub.js';
//my Code for Mitt and My hub

window.popStateDetected = false;
window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});

const app = createApp(App);
app.mixin(mixin);
app.config.globalProperties.emitter = emitter;

app.use(PrimeVue);
app.component("Listbox", Listbox);
app.component("Badge", Badge);
app.component("Inplace", Inplace);
app.component("Divider", Divider);
app.component("OverlayPanel", OverlayPanel);
app.component("InputSwitch", InputSwitch);
app.component("Paginator", Paginator);
app.component("Chip", Chip);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Menu", Menu);
app.component("BlockUI", BlockUI);
app.component("TabMenu", TabMenu);
app.component("Column", Column);
app.component("DataTable", DataTable);
app.component("DataView", DataView);
app.component("DataViewLayoutOptions", DataViewLayoutOptions);
app.component("ProgressSpinner", ProgressSpinner);
app.component("Calendar", Calendar);
app.component("ScrollPanel", ScrollPanel);
app.component("SelectButton", SelectButton);
app.component("InputMask", InputMask);
app.component("InputText", InputText);
app.component("InputNumber", InputNumber);
app.component("MultiSelect", MultiSelect);
app.component("Card", Card);
app.component("Dialog", Dialog);
app.component("Dropdown", Dropdown);
app.component("Button", Button);
app.component("Editor", Editor);
app.component("FileUpload", FileUpload);
app.component("Message", Message);
app.component("Toast", Toast);
app.component("ConfirmDialog", ConfirmDialog);

app.use(ToastService);
app.use(ConfirmationService);

app
  .use(VueTheMask)
  .use(VueLoading)
  .use(store)
  .use(router)
  .mount("#app");
